import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Alert } from '../../../components/atoms'

import { LoadingView } from '../../../../common/components/atoms';
import { USERTYPE } from '../../../common/constants.js';
import { ERROR_MESSAGE } from '../../../common/constants.js';

import shadowPlusTaglineLogo from '../../../components/atoms/data/standard-tagline-color.svg'

class Login extends Component {
    constructor(props) {
        super(props);

        this.refAlert = React.createRef();
        this.state = {
            address: "",
            password: "",
            displayAlert: false,
        }
    }

    componentDidMount() {
        this.props.dispatch({
            type: "ErrorClear",
        });
        this.props.dispatch({
                type: "ClearUserInfo"
            });
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.props.dispatch({
            type: "CheckMaintenance_Saga"
        });
    }

    onSuccess = (user) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        if (user.tempPWFlg) {
            this.props.history.push('/settingpassword');
        } else {
            if(user.type === USERTYPE.ADMIN){
                this.props.history.push('/admin/top');
            } else {
                this.props.history.push('/admin/trainer/top');
            }
        }
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.refAlert.current.setAlertAnime();
        this.setState({ displayAlert: true });
    }

    onClickLogin = (e) => {
        this.props.dispatch({
            type: "LoadStart"
        });
        this.props.dispatch({
            type: 'Login_Saga',
            address: this.state.address,
            password: this.state.password,
            admin: true,
            onSuccess: this.onSuccess,
            onFailure: this.onFailure,
        });
    }

    onChange = (e) => {
        const {name, value} = e.target;
        this.setState({
            [name]: value
        })
    }

    render() {
        const propAlert = {
            display: this.state.displayAlert,
            message: ERROR_MESSAGE["login_failure"],
        }
        return (
            <Body>
                <Logo src={shadowPlusTaglineLogo} style={{width: "150px"}}/>
                <Input>
                    <input type="text" name="address" value={this.state.address} placeholder="メールアドレス"
                        onChange={this.onChange}></input>
                </Input>
                <Input>
                    <input type="password" name="password" value={this.state.password} placeholder="パスワード"
                        onChange={this.onChange}></input>
                </Input>
                <Alert ref={this.refAlert} {...propAlert} />
                <Button onClick={this.onClickLogin}>
                    ログイン
                </Button>
                <LoadingView Display={this.props.loading} />
            </Body>
        );
    }
}

const mapStateToProps = store => {
    return {
        loading: store.loading.loading ? store.loading.loading : false,
    }
};

const connectedLogin = connect(mapStateToProps)(Login);
export { connectedLogin as LoginAdmin };

const Body = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 32px 0;
`;

const Logo = styled.img`
    margin-bottom: 32px;
`;
const Input = styled.div `
    width: 320px;
    text-align: center;
    margin: 10px 0;
    font-size: 14px;
    input {
        width: 80%;
        font-size: 14px;
        padding: 10px 20px;
    }
`;

const Button = styled.div`
    position: fixed;
    top: 384px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 20px;
    padding: 10px 0;
    background-color: #0077FF;
    color: #fff;
    border-radius: 50px;
    width: 300px;
    text-align: center;
    cursor: pointer;
`;
